<script setup lang="ts">
import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';
import AppRawButton from '../appRawButton/AppRawButton.vue';

interface AppTrashCanButtonProps {
  ariaLabel?: string;
}

const props = defineProps<AppTrashCanButtonProps>();

interface AppTrashCanButtonEmits {
  (eventName: 'click', event: MouseEvent): void;
}

const emit = defineEmits<AppTrashCanButtonEmits>();
</script>

<template>
  <AppRawButton
    class="app-trash-can-button"
    :aria-label="props.ariaLabel"
    @click="emit('click', $event)"
  >
    <AppSvgIcon name="trashCanOutlined" size="18" />
  </AppRawButton>
</template>

<style scoped lang="scss">
@use '../../styles/media' as *;

.app-trash-can-button {
  --button-size: 32px;

  width: var(--button-size);
  height: var(--button-size);

  border-radius: var(--border-radius-8);
  background-color: transparent;
  transition: var(--transition-very-short);

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @include on-hover {
    background-color: var(--color-neutral-30);
  }

  &:active {
    transform: matrix(0.95, 0, 0, 0.95, 0, 0);
  }
}
</style>
